<template>
  <base-modal modal-content-class="modal_invite">
    <div class="content">
      <form>
        <h1>{{ $_getTranslations.home_modals_invite_friend_title }}</h1>

        <img src="/static/images/invite_fiends.svg" class="invite_mob_img" alt="mobile image"/>

        <p class="invite_txt">
          {{ $_getTranslations.home_modals_invite_friend_description1 }}
          <span>{{ bonusReward }}</span>
          {{ $_getTranslations.home_modals_invite_friend_description2 }}
        </p>

        <h3>{{ $_getTranslations.home_modals_invite_friend_invite_via_sms }}</h3>

        <base-phone-number-form-input
          v-model="formValues.msisdn"
          :label="$_getTranslations.home_modals_invite_friend_mobile_placeholder"
          :invalid="msisdnInputValidationConfiguration.invalid"
        ></base-phone-number-form-input>

        <div v-if="msisdnInputValidationConfiguration.invalid" class="error_text">
          {{ msisdnInputValidationConfiguration.message }}
        </div>

        <base-button
          container-class="invite"
          @button:click.prevent="handleMsisdnInvite"
        >
          {{ $_getTranslations.home_modals_invite_friend_submit }}
        </base-button>

        <h3 class="invite_email">{{ $_getTranslations.home_modals_invite_friend_invite_via_email }}</h3>

        <base-text-form-input
          v-model="formValues.email"
          :label="$_getTranslations.home_modals_invite_friend_email_placeholder"
          :invalid="emailInputValidationConfiguration.invalid"
        ></base-text-form-input>

        <div v-if="emailInputValidationConfiguration.invalid" class="error_text">
          {{ emailInputValidationConfiguration.message }}
        </div>

        <base-button
          container-class="invite"
          @button:click.prevent="handleEmailInvite"
        >
          {{ $_getTranslations.home_modals_invite_friend_submit }}
        </base-button>
      </form>
    </div>
  </base-modal>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import BaseModal from '../../../common/modal/BaseModal'
import BaseButton from '../../../common/button/BaseButton'
import BaseTextFormInput from '../../../common/formInput/BaseTextFormInput'
import BasePhoneNumberFormInput from '../../../common/formInput/BasePhoneNumberFormInput'
import ValidationMixin from '../../../../common/mixins/validations'
import translationMixin from '../../../../common/mixins/translation'
import {getApiResponseErrorMessage} from '../../../../helpers/api'
import {apiResponseTypeEnum} from '../../../../constants/api'
import {storeErrorMessagesPerResponseType} from '../../../../constants/store'

export default {
  name: 'invite-friend',
  components: {
    BaseModal,
    BaseButton,
    BaseTextFormInput,
    BasePhoneNumberFormInput
  },
  mixins: [
    ValidationMixin,
    translationMixin
  ],
  data () {
    return {
      formValues: {
        msisdn: '',
        email: ''
      },
      msisdnInputValidationConfiguration: {invalid: false, message: ''},
      emailInputValidationConfiguration: {invalid: false, message: ''},
      types: {SMS: 'SMS', MAIL: 'EMAIL'}
    }
  },
  methods: {
    ...mapActions('profile', [
      'sendFriendInvitation'
    ]),
    validateMsisdnInviteForm () {
      const validationConfiguration = {invalid: false, message: ''}

      if (!this.formValues.msisdn) {
        validationConfiguration.invalid = true
        validationConfiguration.message = 'common_error_input_field_required'
      } else if (this.validateMsisdnContent(this.formValues.msisdn).invalid) {
        validationConfiguration.invalid = true
        validationConfiguration.message = 'home_modals_invite_friend_error_msisdn_invalid'
      }

      return validationConfiguration
    },
    validateEmailInviteForm () {
      const validationConfiguration = {invalid: false, message: ''}

      if (!this.formValues.email) {
        validationConfiguration.invalid = true
        validationConfiguration.message = 'common_error_input_field_required'
      } else if (this.validateEmailContent(this.formValues.email).invalid) {
        validationConfiguration.invalid = true
        validationConfiguration.message = 'home_modals_invite_friend_error_email_invalid'
      }

      return validationConfiguration
    },
    resetErrors () {
      for (let inputValidationConfiguration of [this.msisdnInputValidationConfiguration, this.emailInputValidationConfiguration]) {
        if (inputValidationConfiguration.invalid) {
          inputValidationConfiguration.invalid = false
          inputValidationConfiguration.message = ''
        }
      }
    },
    handleMsisdnInvite () {
      this.resetErrors()

      const {invalid, message} = this.validateMsisdnInviteForm()

      if (invalid) {
        this.msisdnInputValidationConfiguration.message = this.$_translateText({key: message})
        this.msisdnInputValidationConfiguration.invalid = true

        return
      }

      this.invite({type: this.types.SMS, input: this.formValues.msisdn})
    },
    handleEmailInvite () {
      this.resetErrors()

      const {invalid, message} = this.validateEmailInviteForm()

      if (invalid) {
        this.emailInputValidationConfiguration.message = this.$_translateText({key: message})
        this.emailInputValidationConfiguration.invalid = true

        return
      }

      this.invite({type: this.types.MAIL, input: this.formValues.email})
    },
    handleResponseError (type, responseEnum) {
      const message = this.$_translateTextByOperator({
        key: getApiResponseErrorMessage(responseEnum, storeErrorMessagesPerResponseType)
      })

      if (type === this.types.SMS) {
        this.msisdnInputValidationConfiguration.message = message
        this.msisdnInputValidationConfiguration.invalid = true
      } else if (type === this.types.MAIL) {
        this.emailInputValidationConfiguration.message = message
        this.emailInputValidationConfiguration.invalid = true
      }
    },
    invite ({type, input}) {
      const payload = {
        name: this.userDetails.username,
        type,
        input
      }
      this.sendFriendInvitation(payload).then(response => {
        const {responseEnum} = response.data

        if (responseEnum === apiResponseTypeEnum.OPERATION_SUCCESS) {
          /**
           * handle success
           */
        } else {
          this.handleResponseError(type, responseEnum)
        }
      })
    }
  },
  computed: {
    ...mapState('common', [
      'availableIntegrations',
      'integrationHeader',
      'userDetails',
      'inviteConfig'
    ]),
    bonusReward () {
      if (this.availableIntegrations.KOREK_IRAQ &&
        (this.integrationHeader === this.availableIntegrations.KOREK_IRAQ.name)
      ) {
        return this.inviteConfig.invitePoints.toLocaleString()
      }

      return this.inviteConfig.invitePoints
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/users/InviteFriend.vue